<template>
  <div class="card mt-3 in-product-varieties">
    <ProductChangeQuantity
      :variety="changeQuantityVariety"
      :type="changeQuantityType"
      @getVarities="getVarities"
    />
    <div class="card-header border-0">
      <h5 class="card-title">تنوع ها</h5>
      <div style="flex: 1"></div>
      <div>
        <Dropdown @input="dropdownInput" :options="dropdownOptions" />
      </div>
    </div>
    <div class="card-body">
      <InputGroup label="رنگ" v-if="$options.configProvider.get('product.hasColor')">
        <treeselect
            :searchable="true"
            :multiple="true"
            :options="realColors"
            noChildrenText="فرزندی وجود ندارد" noOptionsText="موردی وجود ندارد" noResultsText="موردی یافت نشد"
            placeholder="انتخاب رنگ ها"
            v-model="realValue.colors"
        >
          <label :style="'height: 40px'"
                slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
            <div class="color-option-img" :style="'background-color:' + node.raw.code"></div>
            {{ node.label }}
          </label>
        </treeselect>
      </InputGroup>
      <InputGroup label="ویژگی ها">
        <treeselect
          :searchable="true"
          :multiple="true"
          :options="attributes"
          noChildrenText="فرزندی وجود ندارد"
          noOptionsText="موردی وجود ندارد"
          noResultsText="موردی یافت نشد"
          placeholder="انتخاب ویژگی ها"
          v-model="realValue.attributes"
        ></treeselect>
      </InputGroup>
      <b-form-group v-if="realValue.attributes.length">
        <div
          class="mt-3"
          v-for="attribute in selectedAttributes"
          :key="attribute.id"
        >
          <h6>
            مقادیر ویژگی
            <span class="font-weight-bold">{{ attribute.label }}</span>
          </h6>
          <treeselect
            v-if="attribute.type === 'select'"
            :searchable="true"
            :multiple="true"
            :options="attribute.values"
            noChildrenText="فرزندی وجود ندارد"
            noOptionsText="موردی وجود ندارد"
            noResultsText="موردی یافت نشد"
            placeholder="انتخاب کنید"
            v-model="realValue.selected_attribute_values[attribute.id]"
          >
            <div slot="value-label" slot-scope="{ node }">
              {{ node.raw.value }}
            </div>
            <label
              slot="option-label"
              slot-scope="{ node, labelClassName }"
              :class="labelClassName"
            >
              <div>{{ node.raw.value }}</div>
              {{ node.label }}
            </label>
          </treeselect>
          <TreeselectAddable
            v-else-if="attribute.type === 'text'"
            v-model="realValue.selected_attribute_values[attribute.id]"
            :options="getOptions(attribute)"
            :hide-options="true"
            @add-option="
              (option) => {
                addOption(attribute, option);
              }
            "
            placeholder="انتخاب کنید"
          />
        </div>
      </b-form-group>
      <template
        v-if="
          (realValue.selected_attribute_values.length &&
            selectedAttributes.length) ||
          realValue.colors.length
        "
      >
        <table class="table table-responsive-sm table-bordered table-hover">
          <thead>
            <tr>
              <th>عنوان</th>
              <th>قیمت (تومان)</th>
              <th>وضعیت انتشار</th>

              <th
                v-if="$options.configProvider.get('product.showSkuAndBarcode')"
              >
                بارکد
              </th>
              <th>موجودی(انبار اصلی)</th>
              <!-- <th>انتخاب انبار</th> -->
            </tr>
          </thead>
          <draggable
            v-model="sortedVarietiesTemplate"
            tag="tbody"
            v-bind="$options.dragOptions"
          >
            <tr v-for="key in sortedVarietiesTemplate" :key="key">
              <template
                v-for="scope in [{ index: getVarietyTemplateIndexByKey(key) }]"
              >
                <VarietyRow
                  v-if="realValue.varieties[scope.index]"
                  :colors="colors"
                  :row="realValue.varieties[scope.index].ts"
                />

                <td>
                  <b-form-input
                    :style="
                      $options.configProvider.get('product.showSkuAndBarcode')
                        ? 'width: 90%'
                        : ''
                    "
                    type="text"
                    placeholder="قیمت"
                    :value="
                      realValue.varieties[scope.index].data.price | priceinput
                    "
                    @input="
                      (value) => {
                        changeVarietyPrice(scope.index, value);
                      }
                    "
                  ></b-form-input>
                </td>
                <td>
                  <b-form-checkbox
            class="mb-3"
            id="status"
            :disabled="disabled"
             v-model="realValue.varieties[scope.index].data.presale"
            value="1"
            unchecked-value="0"
          >
            <span class="pr-5">پیش فروش</span>
          </b-form-checkbox>
                </td>
                <td
                  v-if="
                    $options.configProvider.get('product.showSkuAndBarcode')
                  "
                >
                  <b-form-group>
                    <b-form-input
                    disabled
                      style="width: 105px"
                      v-model="realValue.varieties[scope.index].data.barcode"
                      type="text"
                      placeholder="بارکد"
                    ></b-form-input>
                  </b-form-group>
                </td>
                <td v-if="hasPermission('changeVarietyQuantity')">
                  <template >
                    <div class="row justify-content-between mb-1 px-2">
                      <div class="">
                        <b-form-input
                          class="d-inline mx-2"
                          :style="
                            $options.configProvider.get(
                              'product.showSkuAndBarcode'
                            )
                              ? 'width: 80%'
                              : 'width: 90%'
                          "
                          type="text"
                          placeholder="موجودی"
                          v-model="
                            realValue.varieties[scope.index].data.main_balance
                          "
                        />
                      </div>
                    </div>
                  </template>
                </td>




                
                <!-- <td >
                  <template >
                      <b-form-group >
                    <multiselect
                    multiple
                        placeholder="انتخاب انبار" 
                        v-model="realValue.varieties[scope.index].data.variety_store"
                        open-direction="bottom"
                        :options="stores"
                        label="label"
                        track-by="id"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        :disabled="disabled"
                    >
                        <template slot="noOptions"> موردی یافت نشد </template>
                        <template slot="noResult"> موردی یافت نشد </template>
                    </multiselect>
                    </b-form-group>
                  </template>
                </td> -->
                <td class="modal-images">
                  <button v-if="(realValue.varieties[scope.index].data.final_price && realValue.varieties[scope.index].data.final_price && realValue.varieties[scope.index].data.final_price.discount != 0) 
                                  || (realValue.varieties[scope.index].data.discountType && realValue.varieties[scope.index].data.discountType !== 'none')" 
                          disabled class="btn btn-info btn-sm ml-1 btn-icon text-nowrap" style="white-space: normal; line-height: 1.2;">
                      دارای<br>تخفیف
                  </button>
                  <a
                    v-b-modal="'modal-variety-information-' + scope.index"
                    class="action-btns1 pt-1 px-2"
                    ><i class="fa fa-edit" data-toggle="tooltip"></i
                  ></a>
                  <a
                    v-b-modal="'modal-variety-image-' + scope.index"
                    class="action-btns1 pt-1 px-2 position-relative"
                    ><i
                      class="fa fa-file-image-o"
                      data-toggle="tooltip"
                      title="عکس ها"
                    ></i>
                    <span
                      class="image-numbers badge badge-secondary"
                      v-if="realValue.varieties[scope.index].data.images.length"
                      >{{
                        realValue.varieties[scope.index].data.images.length
                      }}</span
                    >
                  </a>
                  <printVarietyBtn
                    v-if="$route.name == 'productEdit'"
                    :quantity="realValue.varieties[scope.index].data.main_balance"
                    :varietyId="realValue.varieties[scope.index].data.id"
                  />
                  <b-modal
                    hide-header
                    modal-class="modal-image"
                    hide-footer
                    :id="'modal-variety-image-' + scope.index"
                    title="عکس ها"
                  >
                    <ProductImages
                      hide-shadow
                      v-model="realValue.varieties[scope.index].data.images"
                    />
                  </b-modal>
                  <b-modal
                    modal-class="modal-image"
                    hide-footer
                    :id="'modal-variety-information-' + scope.index"
                    title="اطلاعات تنوع"
                  >
                    <VarietyInformation
                      :gifts="gifts"
                      v-model="realValue.varieties[scope.index].data"
                    />
                    <button
                      class="btn btn-warning"
                      @click="
                        $root.$emit(
                          'bv::hide::modal',
                          'modal-variety-information-' + scope.index
                        )
                      "
                    >
                      بستن
                    </button>
                  </b-modal>
                </td>
              </template>
            </tr>
          </draggable>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
import ProductVarietiesImpl from "@@/core/components/product/ProductVarieties/ProductVarietiesImpl";
import Dropdown from "@@/core/components/shared/Dropdown/Dropdown";
export default {
  components: { Dropdown },
  extends: ProductVarietiesImpl,
};
</script>

<style
  scoped
  src="@@/core/components/product/ProductVarieties/ProductVarietiesStyle.css"
></style>
<style
  src="@@/core/components/product/ProductVarieties/ProductVarietiesStylePublic.css"
></style>
